<div class="layer_details__row" [class.left]="left">
  <div class="layer_details__label">{{ label }}</div>
  <div class="layer_details__value">
    <app-layer-details-optional-measurement-field
      [value]="value"
      [unitsSystem]="unitsSystem"
      type="length"
    ></app-layer-details-optional-measurement-field>
  </div>
</div>
